<template>
  <div
    class="table-reports-container"
    style="transition: opacity 0.1s ease-in-out"
    :class="chartMounted || !isInfinite ? 'opacity_10' : 'opacity_0'"
    :style="`--fixed-cells-length: ${l_totalsItems.length};`"
    data-tst="rep_table"
  >
    <RepChartNav
      v-if="hasNav && overflowRows"
      class="repchart_nav swp_cont_stop"
      :hasHandle="flopGroup === 'swv_flops' || flopGroup === 'swv_turns' ? overflowRows : false"
      style="--height: 100%; width: var(--nav-width)"
      :style="`max-height:calc(${maxChartHeight + 2}px + var(--space-above))`"
      :viewProps="navViewProps"
      :items="items"
      :useHex="useHex"
      :colHeight="colHeight"
      :scrolledPercent="scrolledPercent"
      :hero="hero"
      :opponent="opponent"
      :navResizeDeps="l_navResizeDeps"
      direction="vertical"
      canvasStyle="transform: scaleX(-1)"
      @touchend.stop
      @scroll:update="handleScrollUpdate"
    ></RepChartNav>

    <TableBody
      ref="tableBody"
      class="table-flopreports_body gw_table_small gw_table_excel table-flopreport"
      scrollTrack="large-scroll-track"
      :items="l_items"
      :isInfinite="isInfinite"
      size="small"
      style="
        gap: 0.5rem;
        --padding-th: 0 1rem 0 0.5rem;
        --padding-sortable-th: var(--padding-th);
        --padding-td: 0 0.5rem;
        --height-th: 2.25rem;
        --text-align-th: center;
        --cursor-hover-row: default;
        --ipopeqr-fnt-size: 0.75rem;
        --overflow-x-head: scroll;
        --eveqeqr-width: 5rem;
        --action-width: 6rem;
        --strategy-width: 8rem;
        --z-index-head: 50;
      "
      :style="`
        ${
          flopGroup === 'swv_flops'
            ? `--name-cell-width: 8rem;  ;`
            : flopGroup === 'swv_turns'
              ? `--name-cell-width: 8rem; `
              : flopGroup === 'swv_suits'
                ? `--name-cell-width: 11rem; `
                : flopGroup === 'swv_connectedness'
                  ? `--name-cell-width: 11rem; `
                  : flopGroup === 'swv_pairing'
                    ? `--name-cell-width: 11rem; `
                    : `--name-cell-width: 8rem; `
        }
          --min-width-table-inner: calc(var(--strategy-width) + var(--eveqeqr-width) * 6 + var(--name-cell-width) + ${
            Object.keys(thActions).length
          } * var(--action-width));
        `"
      :class="`clrcode_${colorCoding}`"
      @update:visible="handleTableMounted"
      @update:scrollX="handleScrollXBody"
      @update:scroll="tooltipItem.visible = false"
    >
      <template #head_sticky>
        <TableHead
          ref="tb_head"
          class="large-scroll-track"
          :sortConf="l_sortConf"
          :thead="thead"
          @click:th="handleSort"
        >
          <template
            v-if="flopGroup === 'swv_turns'"
            #th_name
          >
            <TableHeadCell
              style="--max-width-th: 4rem; --min-width-th: 4rem; --padding: 0"
              :sortConf="l_sortConf"
              :item="thead.name"
              tstPrefix="name"
              @click:event.stop="_e => handleSort(thead.name)"
            >
              <UnSwitcherNew
                :hasText="true"
                :hasToggleThreeWay="false"
                :tab="thead.name.sortKey"
                :options="[
                  {
                    flopSortBy: 'idx',
                    sortKey: 'data_idx',
                    text: $t('table_head.cards'),
                  },
                  {
                    flopSortBy: 'idx',
                    sortKey: 'suits',
                    text: $t('table_head.suits'),
                  },
                ]"
                idKey="sortKey"
                @click:threeway="item => handleSort(thead.name)"
                @click="item => handleSort(item)"
              ></UnSwitcherNew>
            </TableHeadCell>
          </template>
          <template
            v-for="slotName in ['th_oop_ev', 'th_oop_eq', 'th_oop_eqr']"
            #[slotName]="v"
            :key="slotName"
          >
            <TableHeadCell
              :sortConf="l_sortConf"
              :item="v.item"
              :tstPrefix="slotName.replace('th_', '')"
              @click="handleSort"
            >
              <div
                class="weight_700 f-center clr-white"
                style="
                  position: absolute;
                  right: 0;
                  top: 0;
                  transform: translate(50%, 0);
                  height: 100%;
                "
              >
                <div
                  style="line-height: 1.1"
                  v-html="v.item.valueName"
                ></div>
              </div>
              <span class="line-height_1">
                {{ v.item.name }}
              </span>
            </TableHeadCell>
          </template>
          <template #after>
            <div class="f-column large-scroll-track">
              <RepTableRow
                v-for="(item, index) in l_totalsItems"
                :key="index"
                :namespace
                :thead="thead"
                :item="item"
                :index="index"
                :useHex="useHex"
                :showBetsIn="showBetsIn"
                :thActions="thActions"
                :thEvEqErq="thEvEqErq"
                :scrolledLeft="scrolledLeft"
                :bettingInfo
                :grouping="grouping"
                class="ignore_reptable_coloredcell"
                @mouseleave:cell="tooltipItem.visible = false"
                @mouseenter:cell="({ el, action }) => setTooltip({ el, action })"
              >
                <template #name>
                  <div
                    v-if="l_solved_action_counts && index === 0"
                    class="d-flex weight_700"
                  >
                    <div>{{ $t('common.used_by') }}</div>
                  </div>
                  <div
                    v-if="
                      (!l_solved_action_counts && index === 0) ||
                      (l_solved_action_counts && index === 1)
                    "
                    class="d-flex text-nowrap weight_700"
                  >
                    {{
                      $t('common.oop_vs_ip', {
                        oop: viewProps.oop_player.position,
                        ip: viewProps.ip_player.position,
                      })
                    }}
                  </div>
                  <div
                    v-if="
                      (!l_solved_action_counts && index === 1) ||
                      (l_solved_action_counts && index === 2)
                    "
                    class="d-flex weight_700"
                  >
                    <i class="mr-1 mdi mdi-filter text-normal"></i>
                    <!-- {{ $t('common.filtered') }} -->
                    <div
                      class="d-flex csst"
                      @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
                    >
                      {{ numFixed(item.ratio * 100, 1) }}%
                      <div class="csst_content text-nowrap">
                        {{ $t('tooltips.how_many_flops') }}
                      </div>
                    </div>
                  </div>
                </template>
              </RepTableRow>
            </div>
          </template>
        </TableHead>
      </template>
      <template #default="{ item, index }">
        <RepTableRow
          :namespace
          :thead="thead"
          :item="item"
          :index="index"
          :useHex="useHex"
          :showBetsIn="showBetsIn"
          :thActions="thActions"
          :thEvEqErq="thEvEqErq"
          :grouping="grouping"
          :flopBoard="flopBoard"
          :scrolledLeft="scrolledLeft"
          :bettingInfo
          :hasLinks="hasLinks"
          :linkParams="linkParams"
          :class="{ reptable_row_active: reportItemId === item.id }"
          class="cursor-pointer"
          @mouseleave:cell="tooltipItem.visible = false"
          @mouseenter:cell="({ el, action }) => setTooltip({ el, action })"
          @mouseenter="
            () => {
              if (item.isEmpty) return
              if (!reportItemId) {
                $store.commit('reports_set', {
                  key: 'reportItem',
                  value: item,
                })
              }
            }
          "
          @click="
            () => {
              if (item.isEmpty) return
              $store.commit('reports_set', {
                key: 'reportItem',
                value: item,
              })
              $store.commit('reports_set', {
                key: 'reportItem_id',
                value: item.id === reportItemId ? null : item.id,
              })
            }
          "
        >
        </RepTableRow>
      </template>
      <template #after
        ><div
          ref="tooltip"
          :style="tooltipItem.visible ? 'opacity: 1' : 'opacity: 0'"
          style="position: fixed; z-index: 100; max-width: 32rem"
          class="csst_content csst_content_visible pa-2"
          v-html="tooltipItem.text"
        ></div>
      </template>
    </TableBody>
  </div>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import { getGroupedActions } from '@/helpers/grouping'
import { unitDecimals } from '@/helpers/constants'
import { throttle } from 'lodash'

import TableHead from '@/components/DataTables/v2/TableHead'
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'
import TableBody from '@/components/DataTables/v2/TableBody'
import RepTableRow from '@/components/DataTables/v2/tables/reports/RepTableRow'

import float_mix from '@/mixins/float_mix'
import table_mix from '@/components/DataTables/table_mix'
import RepChartNav from '@/components/DataTables/v2/tables/reports/RepChartNav'

export default {
  name: 'RepTable',
  components: {
    TableHead,
    TableHeadCell,
    TableBody,
    RepTableRow,
    RepChartNav,
    UnSwitcherNew,
  },
  mixins: [table_mix, float_mix],
  props: {
    namespace: { required: true, type: String },
    items: Array,
    totalsItems: Array,
    showBetsIn: String,
    bettingInfo: Object,
    useHex: Boolean,
    flopGroup: String,
    viewProps: Object,
    grouping: String,
    hero: Object,
    opponent: Object,
    reportItemId: { default: '' },
    colorCoding: String,
    navResizeDeps: Object,
    solution: Array,
    flopBoard: String,
    hasNav: Boolean,
    isInfinite: { type: Boolean, default: true },
    hasLinks: Boolean,
    linkParams: Object,
  },
  data() {
    return {
      tooltipItem: { visible: false },
      scaledRowIdx: null,
      scrolledPercentX: 0,
      colHeight: 30,

      scrolledPercent: 0,
      overflowRows: true,
      maxChartHeight: 999999,
      chartMounted: false,

      scrolledLeft: false,
    }
  },
  methods: {
    setTooltip({ el, action }) {
      if (this.mobile) return
      if (!action.isNa) return

      this.tooltipItem = {
        visible: true,
        text: this.$t('tooltips.bet_size_not_used_in_flop'),
      }

      const referenceEl = el?.[0]?.$el
      const element = this.$refs.tooltip
      const boundary = this.$refs.tableBody?.$el
      const options = {
        placement: 'top',
        strategy: 'fixed',
      }

      if (referenceEl && element && boundary) {
        this.fl_setPositionStyle({ referenceEl, boundary, element, options })
      }
    },
    handleTableMounted() {
      this.handleScrollUpdate({ percentY: this.$store.getters.rep_data_scrolledPercent })
      this.checkOverflow()
      this.chartMounted = true
    },
    handleScrollXBody: throttle(function (e) {
      const { scrollTop, scrollHeight, clientHeight } =
        this.$refs?.tableBody?.$refs?.scroller?.$el || this.$refs?.tableBody?.$refs?.scroller
      this.scrolledPercent = scrollTop / (scrollHeight - clientHeight)
      this.persistScroll()
    }, 1),
    persistScroll: throttle(function (e) {
      this.$store.commit('reports_set', { key: 'scrolledPercent', value: this.scrolledPercent })
    }, 40),
    handleScrollUpdate({ percentY } = {}) {
      const scroller =
        this.$refs?.tableBody?.$refs?.scroller?.$el || this.$refs?.tableBody?.$refs?.scroller
      if (scroller) {
        const { scrollHeight, clientHeight } = scroller
        const res = (scrollHeight - clientHeight) * percentY
        scroller.scrollTop = res
      }
    },
    checkOverflow() {
      if (!this.$refs.tableBody) {
        this.overflowRows = false
        return
      }
      this.overflowRows = this.$refs.tableBody.getOverflowHeight()
      this.maxChartHeight = this.overflowRows
        ? 999999
        : this.$refs.tableBody?.$refs?.scroller?.$el?.offsetHeight
      // console.log('overflowRows', this.overflowRows)
      // console.log('maxChartHeight', this.maxChartHeight)
    },
    handleSort(item) {
      // console.log('handleSort', item)
      if (!item.sortKey) return
      if (item.action_sort) {
        // console.log(this.actionTab, item.sortKey)
        const aaTab = this.actionTab
        if ((aaTab.id || aaTab.code) === item.sortKey) {
          this.toggleAscDesc()
          return
        }
        this.$store.commit('reports_set', { key: 'flop_sortByAction', value: item.action })
        this.$store.commit('reports_set', { key: 'flop_sortBy', value: 'action' })
        this.$store.dispatch('rep_persistSortConf')
      } else if (item.flopSortBy === 'idx') {
        // console.log(this.idxTab, item.sortKey)
        if (this.idxTab === item.sortKey) {
          this.toggleAscDesc()
          return
        }
        this.$store.commit('reports_set', { key: 'flop_sortByIdx', value: item.sortKey })
        this.$store.commit('reports_set', { key: 'flop_sortBy', value: 'idx' })
        this.$store.dispatch('rep_persistSortConf')
      } else {
        if (this.valueTab === item.sortKey) {
          this.toggleAscDesc()
          return
        }
        this.$store.commit('reports_set', { key: 'flop_sortByValue', value: item.sortKey })
        this.$store.commit('reports_set', { key: 'flop_sortBy', value: 'value' })
        this.$store.dispatch('rep_persistSortConf')
      }
    },
    toggleAscDesc() {
      const ascDesc = this.viewProps.flop_sortOrderDesc ? 'asc' : 'desc'
      this.$store.commit('reports_set', { key: 'flop_sortOrder', value: ascDesc })
      this.$store.dispatch('rep_persistSortConf')
    },
    getActions({ tdActions, thActions }) {
      let actions = tdActions
      // console.log(thActions)
      const res = {}
      if (this.grouping !== 'swv_grouping_none') {
        actions = getGroupedActions({
          actions,
          grouping: this.grouping,
          groupValues: ['frequency'],
          raisesFirst: false,
        })
      }
      Object.keys(thActions).forEach(key => {
        const aa = thActions[key].action
        const action = actions.find(a => (a.id ? a.id === aa.id : a.code === aa.code))
        res[key] = {
          ...thActions[key],
          action,
        }
      })
      return res
    },
  },
  computed: {
    l_navResizeDeps() {
      return {
        ...this.navResizeDeps,
        maxChartHeight: this.maxChartHeight,
      }
    },
    navViewProps() {
      return {
        ...this.viewProps,
        colValue: { key: 'strategy' },
      }
    },
    scrollerKey() {
      return this.viewProps.scrollerKey
    },

    valueTab() {
      return this.viewProps.flop_sortBy === 'value' ? this.viewProps.flop_sortByValue : ''
    },
    actionTab() {
      return this.viewProps.flop_sortBy === 'action' ? this.viewProps.flop_sortByAction || {} : ''
    },
    idxTab() {
      return this.viewProps.flop_sortBy === 'idx' ? this.viewProps.flop_sortByIdx : ''
    },

    l_sortConf() {
      const sortBy = this.viewProps.flop_sortBy

      const idx = this.viewProps.flop_sortByIdx
      const action = this.viewProps.flop_sortByAction
      const value = this.viewProps.flop_sortByValue
      // console.log({ sortBy, action, value })
      const res = {
        sortKey: sortBy === 'idx' ? idx : sortBy === 'action' ? action.id || action.code : value,
        sortOrder: this.viewProps.flop_sortOrder,
      }
      // console.log(res)
      return res
    },
    l_items() {
      let res = this.items
      res = res.map(i => {
        const actions = this.getActions({
          tdActions: i.actions,
          thActions: this.thActions,
        })
        const r = {
          ...i,
          tdActions: actions,
        }
        return r
      })
      // console.log(res)
      return res
    },
    l_totalsItems() {
      let res = this.totalsItems
      // debugger
      res = res.map(i => {
        const actions = this.getActions({
          tdActions: i.actions,
          thActions: this.thActions,
        })
        const r = {
          ...i,
          tdActions: actions,
        }
        return r
      })

      // inject a row for counts
      if (this.l_solved_action_counts) {
        // strategy graph in the second column
        const gradients = Object.keys(res[1].actions)
          .reverse()
          .map(a => `linear-gradient(to right, ${res[1].actions[a].hex}, ${res[1].actions[a].hex})`)
          .join(', ')

        let percentage = 0
        const sizes = Object.keys(res[1].actions)
          .map((a, i) => {
            percentage +=
              (this.l_solved_action_counts.solved_action_counts[i] /
                this.l_solved_action_counts.solved_action_counts_total) *
              100
            return `${percentage}% 100%`
          })
          .join(', ')

        res.unshift({
          ...res[1],
          ip: { no_data: true },
          oop: { no_data: true },
          backgrounds: {
            counts: `background-image: ${gradients}; background-size: ${sizes};`,
          },
          tdActions: Object.keys(res[1].tdActions).map((a, i) => {
            const freq =
              this.l_solved_action_counts.solved_action_counts[i] /
              this.l_solved_action_counts.solved_board_count
            return {
              ...res[1].tdActions[a],
              cssStyle: null,
              tdStyle: null,
              action: {
                ...res[1].tdActions[a].action,
                frequency: freq,
              },
              solved_action_count: this.l_solved_action_counts.solved_action_counts[i],
              solved_action_count_percentage: freq,
            }
          }),
        })
      }
      return res
    },
    l_solved_action_counts() {
      return this.$store.getters.rep_data_solvedActionCounts
    },
    thActions() {
      // let solution = JSON.parse(JSON.stringify(this.items[0]?.solution || [])).reverse()
      let actions = JSON.parse(JSON.stringify(this.items[0]?.actions || [])).reverse()
      // let actions = this.items[0]?.actions || []
      if (this.grouping !== 'swv_grouping_none') {
        actions = getGroupedActions({
          actions,
          grouping: this.grouping,
          groupValues: ['frequency'],
          raisesFirst: false,
        })
      }
      const res = {}
      actions.forEach(aa => {
        const id = aa.id || aa.code
        res[id] = {
          name: aa.group_display_name
            ? this.$t(`browse.${aa.group_display_name}`)
            : this.getBetHtml({
                showBetsIn: this.showBetsIn,
                a: aa,
                name: true,
              }),
          id,
          key: id,
          sortKey: id,
          maxWidth: '7rem',
          action: aa,
          action_sort: true,
          cssClass: 'f-center',
          cssStyle:
            '--min-width-th: var(--action-width); --max-width-th: var(--action-width);--line-clamp-th:2;--line-height-th:1',
          tdStyle: '--min-width-td: var(--action-width); --max-width-td: var(--action-width)',
        }
      })
      return res
    },
    thEvEqErq() {
      const insetSortIcon = '--inset-sort-icon: auto auto auto 0;--z-index-th:8;'
      const res = {
        oop_ev: {
          valueName: this.bettingInfo.showEvIn === 'pot' ? 'EV<br>POT%' : 'EV',
          cssStyle: insetSortIcon,
          name: this.$t('table_head.oop'),
          key: 'oop_ev',
          sortKey: 'oop_ev',
          player: 'oop',
          valKey: 'ev',
          decimals: unitDecimals.ev,
        },
        ip_ev: {
          name: this.$t('table_head.ip'),
          // tdStyle: brRight,
          key: 'ip_ev',
          sortKey: 'ip_ev',
          player: 'ip',
          valKey: 'ev',
          decimals: unitDecimals.ev,
        },
        oop_eq: {
          // name: this.$t('table_head.equity_oop_html'),
          valueName: this.$t('table_head.eq'),
          cssStyle: insetSortIcon,
          // tdStyle: brLeft,
          name: this.$t('table_head.oop'),
          key: 'oop_eq',
          sortKey: 'oop_eq',
          player: 'oop',
          valKey: 'eq',
          increment: 100,
          decimals: unitDecimals.eq,
        },
        ip_eq: {
          // name: this.$t('table_head.equity_ip_html'),
          name: this.$t('table_head.ip'),
          // tdStyle: brRight,
          key: 'ip_eq',
          sortKey: 'ip_eq',
          player: 'ip',
          valKey: 'eq',
          increment: 100,
          decimals: unitDecimals.eq,
        },
        oop_eqr: {
          // name: this.$t('table_head.oop_eqr_html'),
          valueName: this.$t('table_head.eqr'),
          cssStyle: insetSortIcon,
          // tdStyle: brLeft,
          name: this.$t('table_head.oop'),
          key: 'oop_eqr',
          sortKey: 'oop_eqr',
          player: 'oop',
          valKey: 'eqr',
          increment: 100,
          decimals: unitDecimals.eqr,
        },
        ip_eqr: {
          // name: this.$t('table_head.ip_eqr_html'),
          name: this.$t('table_head.ip'),
          // tdStyle: brRight,
          key: 'ip_eqr',
          sortKey: 'ip_eqr',
          player: 'ip',
          valKey: 'eqr',
          increment: 100,
          decimals: unitDecimals.eqr,
        },
      }
      Object.keys(res).forEach(key => {
        res[key].cssClass = 'f-center'
        // res[key].cssStyle = `--clr-th:var(--clr-grey-2);
        // res[key].cssStyle = `--min-width-th: var(--eveqeqr-width);
        res[key].cssStyle = `--clr-th:var(--clr-black-10);
                             --max-width-th: var(--eveqeqr-width);
                             --min-width-th: var(--eveqeqr-width);
                             --line-clamp-th:2;
                             --line-height-th:1;
                             ${res[key].cssStyle || ''}`
        res[key].tdStyle = `${
          res[key].tdStyle || ''
        }--min-width-td: var(--eveqeqr-width); --max-width-td: var(--eveqeqr-width)`
      })
      // console.log(res)
      return res
    },
    thFlopGroup() {
      const conf = {
        swv_flops: this.$t('table_head.flops'),
        swv_high_cards: this.$t('table_head.high_cards'),
        swv_suits: this.$t('table_head.suits'),
        swv_pairing: this.$t('table_head.pairing'),
        swv_connectedness: this.$t('table_head.connectedness'),

        swv_turns: this.$t('table_head.turns'),
        swv_card_ranks: this.$t('table_head.card_ranks'),
      }
      // res.cssStyle = '--line-clamp-th: 1;'
      const res = {
        name: {
          name: conf[this.flopGroup],
          // sortKey: 'data_idx',
          sortKey: this.viewProps.flop_sortByIdx || 'data_idx',
          cssClass: 'gw_table_head_cell_sticky',
          flopSortBy: 'idx',
          cssStyle: `--line-clamp-th: 1;
                     min-width: var(--name-cell-width);
                     --min-width-th: var(--name-cell-width);
                     --max-width-th: var(--name-cell-width)`,
          tdStyle: `--min-width-td: var(--name-cell-width);
                    --max-width-td: var(--name-cell-width)`,
        },
      }
      return res
    },
    thead() {
      const res = {
        ...this.thFlopGroup,
        strategy: {
          name: this.$t('table_head.strategy'),
          key: 'category',
          cssClass: 'f-center',
          cssStyle:
            '--min-width-th: var(--strategy-width); --max-width-th: var(--strategy-width);--line-clamp-th: 2; --padding-th: 0;',
          tdStyle: '--min-width-td: var(--strategy-width); --max-width-td: var(--strategy-width)',
        },
        ...this.thActions,
        ...this.thEvEqErq,
      }
      // console.log(res)
      return res
    },
  },
  watch: {
    viewProps() {
      requestAnimationFrame(() => {
        this.checkOverflow()
      })
    },
    scrollerKey() {
      this.scrolledPercent = 0
      this.persistScroll()
    },
  },
}
</script>
<style lang="scss">
.clrcode {
  &_swv_reports_colortext {
    .repfloptblrow {
      &:not(.ignore_reptable_coloredcell) {
        .reptable_coloredcell {
          color: var(--clr-value) !important;
        }
      }
    }
  }
  &_swv_reports_colorcoded {
    .repfloptblrow {
      &:not(.ignore_reptable_coloredcell) {
        .reptable_coloredcell {
          text-shadow: var(--text-shadow_drop);
          background: var(--clr-value) !important;
        }
      }
    }
  }
  &_swv_reports_colorchart {
    .repfloptblrow {
      &:not(.ignore_reptable_coloredcell) {
        .reptable_coloredcell {
          --colorchart-inset: auto auto 0 0.5px;
          &.player_oop {
            --colorchart-inset: auto 0.5px 0 auto;
          }
          &:before {
            content: '';
            position: absolute;
            height: var(--nrm-percent);
            background: var(--clr-value);
            width: 0.75rem;
            border-radius: 2px 2px 0 0;
            inset: var(--colorchart-inset);
          }
        }
      }
    }
  }
  &_swv_reports_colortext_colorchart {
    .repfloptblrow {
      &:not(.ignore_reptable_coloredcell) {
        .reptable_coloredcell {
          --colorchart-inset: auto auto 0 0.5px;
          color: var(--clr-value) !important;
          &.player_oop {
            --colorchart-inset: auto 0.5px 0 auto;
          }
          &:before {
            content: '';
            position: absolute;
            height: var(--nrm-percent);
            background: var(--clr-value);
            width: 0.75rem;
            border-radius: 2px 2px 0 0;
            inset: var(--colorchart-inset);
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.table-reports-container {
  min-height: 0;
  min-width: 0;
  flex: 1;
  display: flex;

  --height-th: 2rem;
  --height-td: 2rem;
  // --nav-width: 2.5rem;
  --nav-width: 3rem;
  gap: 0.5rem;
  --space-above: calc(var(--height-th) + (var(--height-td) * var(--fixed-cells-length)) + 2px);
}
.reptable_row_active {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    height: calc(100% - 1px);
    width: 100%;
    border-radius: 4px;
    z-index: 4;
    background: rgba(255, 255, 255, 0.15);
  }
}
@media screen and (max-width: 1023px) {
  .table-reports-container {
    --nav-width: 2rem;
  }
}
</style>
